<form #email="ngForm">
    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-1">
            <label>From</label>
        </div>
        <div class="p-col-12 p-lg-11">
            <input type="text" [value]="senderName" disabled [ngModelOptions]="{ standalone: true }" pInputText>
        </div>
    </div>
    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-1">
            <label>To </label>
        </div>
        <div class="p-col-12 p-lg-11">
            <span class="p-input-icon-right"  [ngClass]="{ 'p-invalid': toAutocomplete.invalid && (toAutocomplete.touched || toAutocomplete.dirty) }">
                <i class="p-text-normal">
                    <button pButton class="p-button-text" (click)="onClickShowCc()" label="Cc"
                        style="padding-right: 1rem;"></button>
                    <button pButton class="p-button-text" (click)="onClickShowBcc()" label="Bcc"></button>
                </i>
                <p-autoComplete
                    field="emailAddress"
                    [required]="true"
                    name="toRecipients"
                    id="toRecips"
                    #toADropdown
                    #toAutocomplete="ngModel"
                    [(ngModel)]="toRecipients"
                    [suggestions]="emailList"
                    [completeOnFocus]="true"
                    [ngModelOptions]="{ standalone: true }"
                    ngDefaultControl
                    [multiple]="true"
                    (onKeyUp)="onKeyUp($event, 'to')"
                    (keydown)="onToKeyDown($event,'to')"
                    (click)="onInsideClick(toADropdown)"
                    (completeMethod)="emailListDropdown($event.query)"
                    (onSelect)="onSelect($event.value, 'to')"
                    (onBlur)="onBlur($event, 'to')">
                    <ng-template let-toRecip pTemplate="item">
                        <ng-container *ngIf="toRecip.name">
                            {{toRecip.name + "<" + toRecip.emailAddress +">"}}
                        </ng-container>
                    </ng-template>
                </p-autoComplete>
            </span>
            <small *ngIf="toRecipients.length < 1 && (toAutocomplete.touched || toAutocomplete.dirty)"
                class="p-invalid">At least one recipient
                is
                required</small>
        </div>
    </div>
    <div class="p-field p-formgrid p-grid" *ngIf="showCc">
        <div class="p-col-12 p-lg-1">
            <label>Cc</label>
        </div>
        <div class="p-col-12 p-lg-11">
            <p-autoComplete
                field="emailAddress"
                name="ccRecipients"
                #bccAutocomplete
                [(ngModel)]="ccRecipients"
                [suggestions]="emailList"
                [completeOnFocus]="true"
                [ngModelOptions]="{ standalone: true }"
                [multiple]="true"
                (onKeyUp)="onKeyUp($event, 'tocc')"
                (keydown)="onToKeyDown($event,'tocc')"
                (completeMethod)="emailListDropdown($event.query)" required="true"
                (onSelect)="onSelect($event.value, 'tocc')"
                (onBlur)="onBlur($event, 'tocc')">
                <ng-template let-ccRecip pTemplate="item">
                    <ng-container *ngIf="ccRecip.name">
                        {{ccRecip.name + "<" +ccRecip.emailAddress +">"}}
                    </ng-container>
                </ng-template>
            </p-autoComplete>
        </div>
    </div>
    <div class="p-field p-formgrid p-grid" *ngIf="showBcc">
        <div class="p-col-12 p-lg-1">
            <label>Bcc</label>
        </div>
        <div class="p-col-12 p-lg-11">
            <p-autoComplete
                field="emailAddress"
                name="bccRecipients"
                #bccAutocomplete
                [(ngModel)]="bccRecipients"
                [suggestions]="emailList"
                [completeOnFocus]="true"
                [ngModelOptions]="{ standalone: true }"
                [multiple]="true"
                (onKeyUp)="onKeyUp($event, 'bcc')"
                (keydown)="onToKeyDown($event,'tocc')"
                (completeMethod)="emailListDropdown($event.query)"
                (onSelect)="onSelect($event.value, 'bcc')"
                (onBlur)="onBlur($event, 'bcc')">
                <ng-template let-bccRecip pTemplate="item">
                    <ng-container *ngIf="bccRecip.name">
                    {{bccRecip.name + "<" +bccRecip.emailAddress +">"}}
                </ng-container>
                </ng-template>
            </p-autoComplete>
        </div>
    </div>
    <div *ngIf="([1,2].includes(objectTypeId) && channelId)" class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-1">
            <label>Email Template</label>
        </div>
        <div class="p-col-12 p-lg-11">
            <p-dropdown [options]="emailTemplateList" [(ngModel)]="selectedEmailTemplate" [ngModelOptions]="{ standalone: true }" [required]="false" (onChange)="selectEmailTemplate($event)" appendTo="body" placeholder="Select Template" optionLabel="templateName" [showClear]="true" [filter]="true" [filterBy]="'templateName'"></p-dropdown>
        </div>
    </div>

    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-1">
            <label>Subject</label>
        </div>
        <div class="p-col-12 p-lg-11">
            <input type="text" #subject="ngModel" (focus)="selectedInsertField='subject'" (click)="selectedInsertField='subject'"
                [(ngModel)]="emailAudit.subject"
                (ngModelChange)="updatedAddedTags()" id="subject"  pInputText
                [ngClass]="{ 'p-invalid': subject.invalid && (subject.touched || subject.dirty) }" required="true"  autocomplete="off"/>
            <small *ngIf="subject.invalid && (subject.touched || subject.dirty)" class="p-invalid">Subject is required</small>
            <small *ngIf="emailSubjectInvalidTagMsg" class="p-invalid">{{ emailSubjectInvalidTagMsg }}</small>
        </div>
    </div>
    <!-- <div class="p-field p-formgrid p-grid" *ngIf="action === 'compose'">
        <div class="p-col-12 p-lg-1">
            <label>Template</label>
        </div>
        <div class="p-col-12 p-lg-11">
            <p-dropdown appendTo="body" [options]="emailTemplateList" [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="selectedEmailTemplate" name="selectedEmailTemplate" optionLabel="templateName"
                (onChange)="contentByReplacingTemplateFieldValue()">
            </p-dropdown>
        </div>
    </div> -->
    <div class="p-grid">
        <div class="p-col-12">
            <app-lion-attachment-chips [attachments]="emailTemplateAttachments" (removeAttachment)="removeEmailTemplateAttachment($event)">
            </app-lion-attachment-chips>
            <app-lion-attachment-chips [attachments]="emailAttachments"  (removeAttachment)="removeAttachment($event)">
            </app-lion-attachment-chips>
        </div>
        <div [ngClass]="{'p-col-9': ([1,2].includes(objectTypeId) && channelId), 'p-col-12': !([1,2].includes(objectTypeId) && channelId)}">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <input type="file" [ngModelOptions]="{ standalone: true }" name="file-upload" multiple id="file-upload"
                        #fileInput (change)="uploadAttachment(fileInput)" (click)="$event.target.value=null" style="display: none;" />
                        <!-- <p-fileUpload #fileUpload customUpload="true" mode="basic"
                                [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                                (onSelect)="uploadAttachment($event.files, fileUpload)"></p-fileUpload> -->
                    <p-editor #editor (onSelectionChange)="selectedInsertField='body'" [ngModelOptions]="{ standalone: true }" [modules]="editorModules"
                        [(ngModel)]="emailAudit.emailThreads[emailAudit.emailThreads.length > 1 ? emailAudit.emailThreads.length - 1 : 0].messageData"
                        (ngModelChange)="updatedAddedTags()"
                        styleClass="email-compose-editor" name="message" ngDefaultControl>
                        <p-header>
                            <p-menu #attachmentOptions [model]="items" appendTo="body" [baseZIndex]="10000000" [popup]="true">
                            </p-menu>
                            <button pButton class="p-button-text" title="Add Attachments" style="font-size: 16px;"
                                (click)="attachmentOptions.toggle($event)" icon="fa fa-paperclip"></button>

                            <span class="ql-formats">
                                <select class="ql-size" title="Text Header">
                                    <option value="small">small</option>
                                    <option selected></option>
                                    <option value="large">large</option>
                                    <option value="huge">huge</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-size" title="Font Size">
                                    <option value="24px">24</option>
                                    <option value="48px">48</option>
                                    <option value="100px">100</option>
                                    <option value="200px">200</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-bold" title="Bold" aria-label="Bold"></button>
                                <button class="ql-italic" title="Italic" aria-label="Italic"></button>
                                <button class="ql-underline" title="Underline" aria-label="Underline"></button>
                                <button class="ql-strike" title="Strike" aria-label="Strike"></button>
                            </span>
                            <span class="ql-formats">
                                <select title="Text Color" class="ql-color"></select>
                                <span class="ql-format-separator"></span>
                                <select title="Background Color" class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <button title="Ordered List" class="ql-list" value="ordered"></button>
                                <button title="Bullet List" class="ql-list" value="bullet"></button>
                                <select title="Text Alignment" class="ql-align">
                                    <option selected>Gauche</option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button aria-label="Link" title="Insert Link" class="ql-link"></button>
                                <button aria-label="Image" title="Insert Image" class="ql-image"></button>
                                <button class="pi pi-table" title="Insert Table" (click)="insertTable()"></button>
                                <span class="btnBars ai-custom" title="Generate Email with AI" (click)="activityItems.toggle($event)">
                                    <i class="pi ql-ai"   [style.background-image]="'url(' + defaultAIImage + ')'"></i>
                                </span>
                                <p-overlayPanel #activityItems styleClass="activityItems custom-ai">
                                    <ng-template pTemplate>
                                    <ul>
                                        <li (click)="showGenerateEmailDialog(emailGenerationTypes.GenerateEmail);activityItems.hide($event)" icon="pi pi-external-link">
                                        <span><i class="pi pi-envelope p-mr-2"></i>Generate Email</span>
                                        </li>
                                        <li (click)="showGenerateEmailDialog(emailGenerationTypes.GenerateReply);generateReplyFollowup.toggle($event)"
                                            [ngClass]="{'li-disabled': !(emailAudit?.emailThreads[emailAudit.emailThreads.length > 1 ? emailAudit?.emailThreads?.length - 1 : 0]?.messageData?.length > 0) || flag == ''}">
                                        <span><i class="pi pi-reply p-mr-2"></i>Generate reply</span>
                                        </li>
                                        <li (click)="showGenerateEmailDialog(emailGenerationTypes.GenerateFollowup);generateReplyFollowup.toggle($event)"
                                            [ngClass]="{'li-disabled': !(emailAudit?.emailThreads[emailAudit.emailThreads.length > 1 ? emailAudit?.emailThreads?.length - 1 : 0]?.messageData?.length > 0) || flag == ''}">
                                        <span><i class="pi pi-check-square p-mr-2"></i>Generate Followup</span>
                                        </li>
                                    </ul>
                                    </ng-template>
                                    <p-overlayPanel #generateReplyFollowup styleClass="activityItems custom-ai">
                                        <ng-template pTemplate>
                                        <ul>
                                            <li *ngFor="let t of tone" (click)="onClickGenerateReplyFollowup(t)">
                                                <span>
                                                    <i class="pi pi-chevron-circle-down p-mr-2"></i>
                                                    {{t.name}} &nbsp;
                                                    <i *ngIf="isLoadingEmailGenerationScenario && emailGenerationScenario?.tone?.name == t.name" class="pi pi-spin pi-spinner p-mr-2"></i>
                                                </span>
                                            </li>
                                        </ul>
                                        </ng-template>
                                    </p-overlayPanel>
                                </p-overlayPanel>
                            </span>
                        </p-header>
                    </p-editor>

                    <small *ngIf="emailBodyInvalidTagMsg" class="p-invalid">{{ emailBodyInvalidTagMsg }}</small>
                </div>
            </div>
        </div>
        <div *ngIf="([1,2].includes(objectTypeId) && channelId)" class="p-col-3">
            <!-- <label>Available Fields</label> -->
            <p-listbox [options]="fieldTypesByGroup" [group]="true" [metaKeySelection]="false" (onChange)="selectTemplateField($event)" optionLabel="name" [filter]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedType" class="available-field-list" [listStyle]="{'max-height':'295px'}">
                <ng-template let-group pTemplate="group">
                    <div class="listbox-group">
                      <h6 class="p-py-2 p-px-3 p-mb-0">{{group.label}}</h6>
                    </div>
                </ng-template>
                <ng-template let-type pTemplate="item">
                    <div class="type-item" [ngClass]="{'type-item-added': addedFieldTags.includes(type.name), 'type-group-item': type?.childGroup, 'type-child-item': type?.childItem}">
                        <div>{{type.name}}</div>
                    </div>
                </ng-template>
            </p-listbox>
        </div>
    </div>
</form>
<div class="main-parent">
    <p-dialog header="{{emailGenerationScenario.header}}" [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" (onHide)="hideGenerateEmailDialog()">
        <form [formGroup]="emailGenerationForm">
            <div class="pop-parent p-3"><div class="popup-content"></div>
                <div class="field-section">
                    <div class="popup-input pop-text-area">
                        <label>Describe your scenario</label>
                        <!-- <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="emailGenerationScenario.scenario"
                        name="scenario" rows="5" formControlName="scenario"
                            *ngIf="emailGenerationScenario.generationType == 'GenerateEmail'"></textarea> -->
                        <p-editor [(ngModel)]="emailGenerationScenario.scenario" formControlName="scenario"
                            [style]="{'height':'200px'}">
                        </p-editor>
                        <small *ngIf="emailGenerationForm.get('scenario').invalid && emailGenerationForm.get('scenario').touched" class="p-invalid">
                            Scenario can't be empty.
                        </small>

                    </div>
                    <div class="popup-input">
                        <label>Tone</label>
                        <p-dropdown [options]="tone" [(ngModel)]="emailGenerationScenario.tone" optionLabel="name" formControlName="tone"></p-dropdown>
                    </div>
                </div>
                <div class="footer-button">
                    <p-button label="{{isLoadingEmailGenerationScenario? 'Generating...' : 'Generate'}}" [loading]="isLoadingEmailGenerationScenario" (click)="getGenerateEmail()"></p-button>
                </div>
            </div>
        </form>
    </p-dialog>
</div>
